import { create } from "zustand";
export const useAuthStore = create(set => ({
    isOpen: false,
    step: "login",
    provider: undefined,
    accessToken: undefined,
    chain: undefined,
    isAuthenticated: false,
    isConnecting: false,
    isConnected: false,
    onSuccess: undefined,
    onError: undefined,
    setB3ModalOpen: isOpen => set({ isOpen }),
    setStep: step => set({ step }),
    setIsConnecting: isConnecting => set({ isConnecting }),
    setIsConnected: isConnected => set({ isConnected }),
    setIsAuthenticated: isAuthenticated => set({ isAuthenticated }),
    startAuth: params => set({
        isOpen: true,
        step: params.accessToken ? "permissions" : "login",
        provider: params.provider,
        accessToken: params.accessToken,
        chain: params.chain,
        onSuccess: params.onSuccess,
        onError: params.onError,
    }),
    reset: () => set({
        isOpen: false,
        step: "login",
        provider: undefined,
        accessToken: undefined,
        chain: undefined,
        isAuthenticating: false,
        isAuthenticated: false,
        onSuccess: undefined,
        onError: undefined,
    }),
    isAuthenticating: true,
    setIsAuthenticating: isAuthenticating => set({ isAuthenticating: isAuthenticating }),
    hasStartedConnecting: false,
    setHasStartedConnecting: hasStartedConnecting => set({ hasStartedConnecting }),
    justCompletedLogin: false,
    setJustCompletedLogin: justCompletedLogin => set({ justCompletedLogin }),
}));
